export class AdminDashboardDetailModel {
    constructor() {
        this.activeEntriesCount = 0;
        this.inReviewEntriesCount = 0;
        this.recentlyUpdatedEntriesCount = 0;
        this.clientFavouriteEntriesCount = 0;
        this.totalOrganizationCount = 0;
        this.loggedInOrganizationCount = 0;
        this.notLoggedInOrganizationCount = 0;
        this.mapStates = [];
        this.mapAnalystDetails = [];
    }
}
export default class AdminDashboardDetail extends AdminDashboardDetailModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
